module.exports = __webpack_public_path__ + "fonts/opensans-thin.fc38956c87eb22652b2e.ttf";